module.exports = __webpack_public_path__ + "img/service-01-pic-4.add0f607.jpg";